import { MRT_SortingState } from '@talentmesh/table';
import { useEffect, useState } from 'react';
import { useIdentifiedListContext } from './IdentifiedListContext';
import SortingDirection from '@/Models/SortingDirection';

const useManualSorting = () => {
    const { setOptions } = useIdentifiedListContext();
    const state = useState<MRT_SortingState>([]);
    const [sorting] = state;

    useEffect(() => {
        if (sorting.length > 0) {
            const { id, desc } = sorting[0];
            const sortingDirection = desc ? SortingDirection.Desc : SortingDirection.Asc;

            setOptions((p) => ({ ...p, sortByColumn: id, sortingDirection }));
        } else {
            setOptions((p) => ({ ...p, sortByColumn: undefined, sortingDirection: undefined }));
        }
    }, [sorting, setOptions]);

    return state;
};

export default useManualSorting;
